// extracted by mini-css-extract-plugin
export default {"container":"r9itj_container","tag-container":"zoOcU_tag-container","tag-title":"G1x56_tag-title","tag-icon":"pVpg7_tag-icon","divider":"BjuSr_divider"};